import { render } from "./WorkView.vue?vue&type=template&id=bb0a673e&scoped=true"
import script from "./WorkView.vue?vue&type=script&lang=js"
export * from "./WorkView.vue?vue&type=script&lang=js"

import "./WorkView.vue?vue&type=style&index=0&id=bb0a673e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0a673e"]])

export default __exports__